import { render, staticRenderFns } from "./ModbusTest.vue?vue&type=template&id=fca02e2a&scoped=true"
import script from "./ModbusTest.vue?vue&type=script&lang=js"
export * from "./ModbusTest.vue?vue&type=script&lang=js"
import style0 from "./ModbusTest.vue?vue&type=style&index=0&id=fca02e2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca02e2a",
  null
  
)

export default component.exports